import Logger from '../lib/logger';
import StorageService from '../lib/storage.service';

class CartPageModal extends HTMLElement {
	#NAME = 'CartPageModal';
	abortController;
	modal;
	count = 0;
	seen;

	constructor() {
		super();
		Logger.info(`${this.#NAME} > constructor`);
		this.seen = StorageService.get('cart-required-products-seen') || [];
	}

	connectedCallback() {
		Logger.info(`${this.#NAME} > connectedCallback`);
		this.abortController = new AbortController();
		const { signal } = this.abortController;
		setTimeout(() => {
			this.modal = this.querySelector('dharma-modal[id="required-products-modal"]');
			this.modal.addEventListener('modalevent', (e) => this.#onModalEvent(e), { signal });
			if (this.count > 0) {
				const prevSeenLength = this.seen.length;
				// get product ids from all product grid items in modal
				const unseen = Array.from(this.modal.querySelectorAll('[data-product-grid-item]')).map(el => el.dataset.productId);
				// use Set so all items in array are unique, no duplicates
				this.seen = Array.from(new Set([...this.seen, ...unseen]));
				if (this.seen.length > prevSeenLength) this.modal.dataset.show = 'true';
			}
		}, 40);
	}

	disconnectedCallback() {
		this.abortController.abort();
		this.abortController = null;
	}

	static get observedAttributes() {
    return ['required-count'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
		Logger.info(`${this.#NAME} > attributeChangedCallback > ${name}, ${oldValue}, ${newValue}`);
		if (name === 'required-count') {
			this.count = parseInt(newValue);
		}
	}

	#onModalEvent(e) {
		Logger.info(`${this.#NAME} > #onModalEvent >`, e.detail);
		if (e.detail.name === 'open') {
			Logger.info(`${this.#NAME} > StorageService.save > cart-required-products-seen`, this.seen);
			StorageService.save('cart-required-products-seen', this.seen);
		} else if (e.detail.name !== 'close') {
			this.modal.dataset.show = 'false';
		}
	}
	
}

customElements.define('cart-page-modal', CartPageModal);
